import React, { ChangeEvent, KeyboardEvent, useState } from 'react';
import {IProps} from './types';
import * as S from './styles';
import C from '@assets/themes/colors';
import RemoveIcon from '@assets/icons/removeIcon';
import Chips from '@components/Chips';
import { noSpecialCharacters } from '@utils/userUtils';

const CustomTag:React.FC<IProps> = (props) => {

  const [value, setValue] = useState("");
  const [errorRepeated, setErrorRepeated] = useState(false);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    const repeatedIndex = props.items.findIndex((item) => item === e.target.value.trim());
    if (repeatedIndex >= 0) setErrorRepeated(true);
    else setErrorRepeated(false);
  }

  const handleKeyPress = (e: KeyboardEvent<HTMLInputElement>) => {
    const newValue = value.trim();
    if (e.key === "Enter" && newValue !== "") {
      if (!errorRepeated)
      props.addItems(newValue, props.id);
      setValue("");
    } else {
      noSpecialCharacters(e);
    }
  }

  const cleanValue = () => {
    setValue("");
  }

  return (
    <S.Root style={props.containerStyle} >
      <S.TopContainer style={props.titleStyle} >
        {props.title ?? `Custom Tags`}
      </S.TopContainer>
      <S.InputContainer>
        <S.TextContainer
          id="custom-tag-input"
          placeholder={props.placeholder ?? `Enter Custom Tags`}
          value={value}
          onChange={handleChange}
          onKeyPress={handleKeyPress}
          onPaste={noSpecialCharacters}
          disabled={props.disabled}
          textColor={value === "" ? C.DARK_GRAY : C.BLACK}
        />
        {  
          value !== "" &&
          <S.RemoveIconContainer onClick={cleanValue} >
            <RemoveIcon />
          </S.RemoveIconContainer>
        }
        {  
          value !== "" &&
          <S.TipLabel textColor={errorRepeated ? C.RED : '#8891a0'} >
            {errorRepeated ? "Repeated tag" : "Hit enter to add tag"}
          </S.TipLabel>
        }
      </S.InputContainer>
      {
        props.items?.length > 0 ? 
          <S.ChipsContainer>
            <Chips 
              items={props.items}
              handleRemove={props.removeItems}
            />
          </S.ChipsContainer>
        : !(props.hideAuxText) ?
          <S.HelpTextContainer>
            <S.HelpText>
              Add tags to selected template. 
            </S.HelpText>
            <S.HelpText>
              Start with Design Type and subsequent options will change depending on your selection.
            </S.HelpText>
          </S.HelpTextContainer>
        :
          <></>
      }
    </S.Root >
  );
}

export default CustomTag;